import { getLayerByPlanId, zoomToPlanId } from './map/tools';

export const writeObject = (obj, parent) => {
  const list = document.createElement('ul');
  // How to loop an object (2 of many ways):
  // Object.keys(obj).forEach(key => console.log(`${key}: ${obj[key]}`));
  // for (let [key, v] of Object.entries(obj)) console.log(`${key}: ${v}`);
  Object.entries(obj).forEach(([key, value]) => {
    if (['geometry', 'område', 'SHAPE'].indexOf(key) > -1) return; // skip
    // console.log(`${key}: ${value} (${typeof value})`); // null is object
    const item = document.createElement('li');
    const date = value instanceof Date;
    const nested = value && ((typeof value) === 'object') && !date;
    const displayed = date ? value.toLocaleDateString() : (nested ? '' : value);
    item.innerHTML = `${key}: ${displayed}`;
    if (nested) writeObject(value, item);
    list.appendChild(item);
  });
  parent.appendChild(list);
  return list;
};

export const separateObjectKeysStartingWith = (obj, keyCheck) => {
  const without = {};
  const w = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (key.startsWith(keyCheck)) w[key.slice(keyCheck.length)] = value;
    else without[key] = value;
  });
  return [without, w];
};

export const retrievePlanCategory = () => {
  if (currentRadio.checked) return currentRadio.value;
  if (fremtidigRadio.checked) return fremtidigRadio.value;
  if (kommuneRadio.checked) return kommuneRadio.value;
  if (reguleringsRadio.checked) return reguleringsRadio.value;
  return null;
};

export const createSlider = planId => {
  const slider = document.createElement('input');
  slider.type = 'range';
  slider.className = 'slider';
  slider.title = 'Gjennomsiktighet';
  return slider;
};

export const createNavigationTo = (planId, layer) => {
  if (!layer) layer = getLayerByPlanId(planId);
  const fitBtn = document.createElement('button');
  fitBtn.type = 'button';
  fitBtn.className = 'custom-btn green-transition fit-geo';
  fitBtn.setAttribute('ariaLabel', 'Zoom');
  fitBtn.title = 'Zoom';
  fitBtn.innerHTML = '<span aria-hidden="true">&#128065;</span>'; // eye
  fitBtn.onclick = () => zoomToPlanId(planId, layer);
  return fitBtn;
};

export const mangel = () => {
  const list = [];
  listOfLayers.querySelectorAll('li > ul > li.disabled').forEach(li => {
    const cb = li.querySelector('input[type="checkbox"]');
    if (cb) list.push(cb.value);
  });
  const csv = list.join(', ');
  return csv ?
    `Planer som har planavgrensning men ingen arealformål: [${csv}].\n` : '';
};
